// ZERBAY Sürüm 2 (s2/09) header controller: header state (transparent over the home hero / solid), the desktop
// "Shoes" panel (a disclosure) and the phone menu (a modal <dialog>). Markup: sections/zerbay-header.liquid.
// One run per page; every header root is bound once and again after a theme-editor re-render.
(function () {
  var root = document.documentElement;

  if (root.hasAttribute('data-zb-hd-js')) {
    return;
  }

  root.setAttribute('data-zb-hd-js', '');

  /* s3/61: body.user-is-tabbing on the first Tab key, as on the global store, so keyboard-only focus rings can be told from
     tap/mouse focus (the theme CSS keys several rules to this class). */
  (function () {
    function onFirstTab(e) {
      if (e.key === 'Tab' || e.keyCode === 9) {
        if (document.body) document.body.classList.add('user-is-tabbing');
        window.removeEventListener('keydown', onFirstTab);
      }
    }
    window.addEventListener('keydown', onFirstTab);
  })();

  var DESKTOP_QUERY = '(min-width: 960px)';
  var EXIT_MS = 240;
  var SCROLL_OPTIONS = { passive: true };
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])';

  function each(list, fn) {
    Array.prototype.forEach.call(list || [], fn);
  }

  function debounce(fn, delay) {
    var timeout;

    return function () {
      window.clearTimeout(timeout);
      timeout = window.setTimeout(fn, delay);
    };
  }

  function matches(query) {
    return !!(window.matchMedia && window.matchMedia(query).matches);
  }

  function focusEl(element) {
    if (!element || typeof element.focus !== 'function') {
      return;
    }

    try {
      element.focus({ preventScroll: true });
    } catch (error) {
      element.focus();
    }
  }

  function setScrolledState(minimalHeader) {
    var isScrolled = window.scrollY > 4;

    minimalHeader.classList.toggle('scrolled', isScrolled);
    minimalHeader.classList.toggle('shadow', isScrolled);
  }

  function checkDropdowns(header) {
    var dropdowns = header.querySelectorAll('.dropdown-wrap');

    dropdowns.forEach(function (dropdown) {
      dropdown.classList.remove('dropdown-right');

      var parent = dropdown.closest('.nav-item, .dropdown-item');

      if (!parent) {
        return;
      }

      var previousDisplay = dropdown.style.display;
      var previousVisibility = dropdown.style.visibility;

      dropdown.style.visibility = 'hidden';
      dropdown.style.display = 'block';

      var rect = dropdown.getBoundingClientRect();

      dropdown.style.display = previousDisplay;
      dropdown.style.visibility = previousVisibility;

      if (rect.right > window.innerWidth - 12) {
        dropdown.classList.add('dropdown-right');
      }
    });
  }

  function headerOf(element) {
    return element && element.closest ? element.closest('[data-zb-hd]') : null;
  }

  function isOpen(dialog) {
    return !!dialog && dialog.hasAttribute('open');
  }

  function openDialogs(scope) {
    return Array.prototype.filter.call((scope || document).querySelectorAll('dialog.zb-menu'), isOpen);
  }

  // Header state: transparent is allowed only on the home page (CSS: body.zb-home); it ends as soon as the page has
  // scrolled (the existing .scrolled class), a dialog is open or the panel is open.
  function updateState(header) {
    if (!header) {
      return;
    }

    var bar = header.querySelector('[data-zb-header-minimal]');
    var scrolled = !!bar && bar.classList.contains('scrolled');
    var busy = header.hasAttribute('data-zb-open') || header.hasAttribute('data-zb-panel-open');

    header.classList.toggle('is-solid', scrolled || busy);
  }

  function syncLock() {
    var anyOpen = openDialogs().length > 0;

    root.classList.toggle('zb-scroll-lock', anyOpen);

    if (document.body) {
      // zerbay-overrides.css hides the Shopify Inbox bubble while this class is on the body.
      document.body.classList.toggle('zb-mobile-menu-open', anyOpen);
    }
  }

  function setTriggers(header, id, expanded) {
    if (!header || !id) {
      return;
    }

    each(header.querySelectorAll('[data-zb-dialog-open]'), function (trigger) {
      if (trigger.getAttribute('data-zb-dialog-open') === id) {
        trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      }
    });
  }

  // ---- Dialogs (phone menu) -------------------------------------------------------------------------------
  function openDialog(dialog, opener) {
    if (!dialog || isOpen(dialog)) {
      return;
    }

    var header = headerOf(dialog);
    var modal = typeof dialog.showModal === 'function';

    window.clearTimeout(dialog._zbTimer);
    dialog.classList.remove('is-closing');
    dialog._zbClosing = false;
    dialog._zbOpener = opener || null;

    if (modal) {
      try {
        dialog.showModal();
      } catch (error) {
        modal = false;
      }
    }

    // No showModal (old browsers): the open attribute, the scroll lock and a raised header stand in for the top layer.
    dialog._zbFallback = !modal;

    if (!modal) {
      dialog.setAttribute('open', '');
      dialog.setAttribute('aria-modal', 'true');
    }

    if (header) {
      header.setAttribute('data-zb-open', '');
      setTriggers(header, dialog.id, true);
      updateState(header);
    }

    syncLock();

    var focusKey = opener ? opener.getAttribute('data-zb-focus') : null;
    var target = (focusKey && dialog.querySelector('[data-zb-focus-target="' + focusKey + '"]')) ||
      dialog.querySelector('[data-zb-dialog-close]');

    focusEl(target);
  }

  function afterClose(dialog, options) {
    var header = headerOf(dialog);
    var opener = dialog._zbOpener;

    window.clearTimeout(dialog._zbTimer);
    dialog.classList.remove('is-closing');
    dialog._zbClosing = false;
    dialog._zbOpener = null;
    dialog._zbFallback = false;
    dialog.removeAttribute('aria-modal');

    if (header) {
      setTriggers(header, dialog.id, false);

      if (openDialogs(header).length === 0) {
        header.removeAttribute('data-zb-open');
      }

      updateState(header);
    }

    syncLock();

    if (!options.handoff && !options.noFocus && opener && document.documentElement.contains(opener)) {
      focusEl(opener);
    }
  }

  function finishClose(dialog, options) {
    if (isOpen(dialog)) {
      if (!dialog._zbFallback && typeof dialog.close === 'function') {
        dialog._zbSelfClose = true;
        dialog.close();
      } else {
        dialog.removeAttribute('open');
      }
    }

    afterClose(dialog, options || {});
  }

  // options: handoff (no animation, no focus return), instant (no animation), noFocus (no focus return).
  function closeDialog(dialog, options) {
    options = options || {};

    if (!isOpen(dialog)) {
      return;
    }

    var now = options.handoff || options.instant || matches('(prefers-reduced-motion: reduce)');

    if (dialog._zbClosing && !now) {
      return;
    }

    window.clearTimeout(dialog._zbTimer);

    if (now) {
      finishClose(dialog, options);
      return;
    }

    dialog._zbClosing = true;
    dialog.classList.add('is-closing');
    dialog._zbTimer = window.setTimeout(function () {
      finishClose(dialog, options);
    }, EXIT_MS);
  }

  // The menu's cart and search buttons open another layer: close the menu at once (no focus return to the inert menu
  // button), then focus and click the header's own trigger, so the drawer or search window opens as from the header.
  function handOff(dialog, key) {
    var header = headerOf(dialog);
    var selector = key === 'cart' ? '.zb-hd__bar .mini-cart-wrap' : '.zb-hd__bar search-button > button';
    var trigger = header ? header.querySelector(selector) : null;

    if (!trigger) {
      closeDialog(dialog);
      return;
    }

    closeDialog(dialog, { handoff: true });
    focusEl(trigger);
    trigger.click();
  }

  function bindDialog(dialog) {
    if (dialog._zbBound) {
      return;
    }

    dialog._zbBound = true;

    // Esc: run the same close (exit animation, focus return) instead of the browser's.
    dialog.addEventListener('cancel', function (event) {
      event.preventDefault();
      closeDialog(dialog);
    });

    // A close the browser made on its own (e.g. a repeated Esc) still resets the lock, the triggers and the state.
    dialog.addEventListener('close', function () {
      if (dialog._zbSelfClose) {
        dialog._zbSelfClose = false;
        return;
      }

      afterClose(dialog, {});
    });

    dialog.addEventListener('click', function (event) {
      var target = event.target;

      if (target === dialog) {
        closeDialog(dialog);
        return;
      }

      var handoff = target.closest ? target.closest('[data-zb-handoff]') : null;

      if (handoff && dialog.contains(handoff)) {
        event.preventDefault();
        handOff(dialog, handoff.getAttribute('data-zb-handoff'));
        return;
      }

      if (target.closest && target.closest('[data-zb-dialog-close]')) {
        closeDialog(dialog);
        return;
      }

      if (target.closest && target.closest('a[href]')) {
        closeDialog(dialog);
      }
    });
  }

  // ---- Desktop panel ("Shoes"): a disclosure under the header ----------------------------------------------
  function panelParts(header) {
    return {
      button: header.querySelector('[data-zb-panel-toggle]'),
      panel: header.querySelector('[data-zb-panel]'),
      scrim: header.querySelector('[data-zb-panel-scrim]'),
      nav: header.querySelector('.zb-hd__nav')
    };
  }

  function panelIsOpen(header) {
    var parts = panelParts(header);

    return !!parts.panel && !parts.panel.hidden;
  }

  function setPanel(header, open, focusBack) {
    var parts = panelParts(header);

    if (!parts.button || !parts.panel || panelIsOpen(header) === open) {
      return;
    }

    parts.panel.hidden = !open;

    if (parts.scrim) {
      parts.scrim.hidden = !open;
    }

    parts.button.setAttribute('aria-expanded', open ? 'true' : 'false');

    if (open) {
      header.setAttribute('data-zb-panel-open', '');
    } else {
      header.removeAttribute('data-zb-panel-open');
    }

    updateState(header);

    if (!open && focusBack) {
      focusEl(parts.button);
    }
  }

  function bindPanel(header) {
    var parts = panelParts(header);

    // Element listeners are added once per element: a theme-editor unload/load of the same markup must not double them.
    if (!parts.button || !parts.panel || parts.button._zbBound) {
      return;
    }

    parts.button._zbBound = true;
    parts.button.addEventListener('click', function (event) {
      event.preventDefault();
      setPanel(header, !panelIsOpen(header), false);
    });

    if (parts.scrim) {
      parts.scrim.addEventListener('click', function () {
        setPanel(header, false, false);
      });
    }

    // Keyboard focus that leaves the nav closes the panel. A click on an empty part of the panel gives no
    // relatedTarget and must not close it; clicks outside are handled by the document listener.
    if (parts.nav) {
      parts.nav.addEventListener('focusout', function (event) {
        var next = event.relatedTarget;

        if (next && !parts.nav.contains(next)) {
          setPanel(header, false, false);
        }
      });
    }
  }

  // ---- Per header root -------------------------------------------------------------------------------------
  function initHeader(header) {
    if (!header || header.hasAttribute('data-zb-bound')) {
      return;
    }

    var minimalHeader = header.querySelector('[data-zb-header-minimal]');

    if (!minimalHeader) {
      return;
    }

    header.setAttribute('data-zb-bound', '');
    root.classList.add('header-layout-minimal');

    setScrolledState(minimalHeader);
    checkDropdowns(header);
    updateState(header);

    var onScroll = function () {
      setScrolledState(minimalHeader);
      updateState(header);
    };

    var onResize = debounce(function () {
      checkDropdowns(header);
    }, 160);

    window.addEventListener('scroll', onScroll, SCROLL_OPTIONS);
    window.addEventListener('resize', onResize);

    header._zbOff = function () {
      window.removeEventListener('scroll', onScroll, SCROLL_OPTIONS);
      window.removeEventListener('resize', onResize);
    };

    each(header.querySelectorAll('[data-zb-dialog-open]'), function (trigger) {
      if (trigger._zbBound) {
        return;
      }

      trigger._zbBound = true;
      trigger.addEventListener('click', function (event) {
        var dialog = document.getElementById(trigger.getAttribute('data-zb-dialog-open'));

        if (!dialog) {
          return;
        }

        event.preventDefault();

        if (isOpen(dialog)) {
          closeDialog(dialog);
        } else {
          openDialog(dialog, trigger);
        }
      });
    });

    each(header.querySelectorAll('dialog.zb-menu'), bindDialog);
    bindPanel(header);
  }

  // Theme editor: a re-rendered section is unbound first; nothing stays open, locked or listening.
  function teardown(header) {
    each(openDialogs(header), function (dialog) {
      closeDialog(dialog, { instant: true, noFocus: true });
    });

    setPanel(header, false, false);

    if (typeof header._zbOff === 'function') {
      header._zbOff();
      header._zbOff = null;
    }

    header.removeAttribute('data-zb-open');
    header.removeAttribute('data-zb-bound');
    syncLock();
  }

  function eachHeader(scope, fn) {
    if (!scope || !scope.querySelectorAll) {
      return;
    }

    if (scope.matches && scope.matches('[data-zb-hd]')) {
      fn(scope);
    }

    each(scope.querySelectorAll('[data-zb-hd]'), fn);
  }

  // ---- Document-level listeners (added once; they look up the current elements at event time) ------------
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' || event.key === 'Esc') {
      each(document.querySelectorAll('[data-zb-hd][data-zb-panel-open]'), function (header) {
        setPanel(header, false, true);
      });

      // Without showModal there is no cancel event.
      each(openDialogs(), function (dialog) {
        if (dialog._zbFallback) {
          closeDialog(dialog);
        }
      });

      return;
    }

    // Without showModal the page behind is not inert: keep Tab inside the open menu.
    if (event.key !== 'Tab') {
      return;
    }

    each(openDialogs(), function (dialog) {
      if (!dialog._zbFallback) {
        return;
      }

      var focusables = Array.prototype.filter.call(dialog.querySelectorAll(FOCUSABLE), function (element) {
        return element.getClientRects().length > 0;
      });

      if (!focusables.length) {
        return;
      }

      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      var active = document.activeElement;

      if (!dialog.contains(active)) {
        event.preventDefault();
        focusEl(first);
      } else if (event.shiftKey && active === first) {
        event.preventDefault();
        focusEl(last);
      } else if (!event.shiftKey && active === last) {
        event.preventDefault();
        focusEl(first);
      }
    });
  });

  document.addEventListener('click', function (event) {
    each(document.querySelectorAll('[data-zb-hd][data-zb-panel-open]'), function (header) {
      var nav = header.querySelector('.zb-hd__nav');

      if (nav && !nav.contains(event.target)) {
        setPanel(header, false, false);
      }
    });
  });

  // Back/forward cache: a restored page never comes back with the menu or the panel open.
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) {
      return;
    }

    each(document.querySelectorAll('[data-zb-hd]'), function (header) {
      each(openDialogs(header), function (dialog) {
        closeDialog(dialog, { instant: true, noFocus: true });
      });

      setPanel(header, false, false);
      updateState(header);
    });
  });

  // Crossing 960px: the phone menu closes on desktop, the desktop panel closes on phones.
  if (window.matchMedia) {
    var desktopQuery = window.matchMedia(DESKTOP_QUERY);
    var onBreakpoint = function () {
      each(document.querySelectorAll('[data-zb-hd]'), function (header) {
        if (desktopQuery.matches) {
          each(openDialogs(header), function (dialog) {
            closeDialog(dialog, { instant: true, noFocus: true });
          });
        } else {
          setPanel(header, false, false);
        }
      });
    };

    if (typeof desktopQuery.addEventListener === 'function') {
      desktopQuery.addEventListener('change', onBreakpoint);
    } else if (typeof desktopQuery.addListener === 'function') {
      desktopQuery.addListener(onBreakpoint);
    }
  }

  document.addEventListener('shopify:section:unload', function (event) {
    eachHeader(event.target, teardown);
  });

  document.addEventListener('shopify:section:load', function (event) {
    eachHeader(event.target, initHeader);
    syncLock();
  });

  // Keep the custom cart-count badges ([data-cart-mini-count]: header and phone menu) in sync with
  // Horizon cart updates — they aren't <cart-icon>s, so they don't auto-update
  // when items are added or removed in the drawer.
  document.addEventListener('cart:update', function (event) {
    var data = event && event.detail ? event.detail.data : null;
    var count = data && typeof data.itemCount === 'number' ? data.itemCount : null;
    if (count === null) return;
    document.querySelectorAll('[data-cart-mini-count]').forEach(function (el) {
      el.textContent = count > 0 ? String(count) : '';
    });
  });

  function init() {
    each(document.querySelectorAll('[data-zb-hd]'), initHeader);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}());

// ZERBAY Sürüm 2 (s2/17): html.zb-vscroll is on while the page is taller than the window, so it has a scrollbar.
// zerbay-overrides.css uses it only while the search window is open, to keep the scrollbar's space under the
// scroll lock; it has no effect otherwise. The body's size follows both the content and the window height
// (body min-height: 100svh in base.css), so watching the body keeps the class current.
(function () {
  if (window.zbVScrollInit || !window.ResizeObserver || !document.body) {
    return;
  }

  window.zbVScrollInit = true;

  var root = document.documentElement;

  new ResizeObserver(function () {
    root.classList.toggle('zb-vscroll', root.scrollHeight > root.clientHeight);
  }).observe(document.body);
}());

// ZERBAY TR legal: pre-contract consent above ÖDEME (snippets/cart-summary.liquid). The checkbox is
// `required` with form="cart-form", so the browser already blocks checkout while it is unticked; this
// replaces the browser's bubble with the Turkish line under the box and saves the answer on the cart.
// Delegated listeners, because the drawer and /cart re-render their markup after every cart change.
(function () {
  if (window.zbConsentInit) {
    return;
  }

  window.zbConsentInit = true;

  var SELECTOR = '[data-zb-consent-input]';

  function isConsentInput(target) {
    return target instanceof HTMLInputElement && target.matches(SELECTOR);
  }

  function setError(input, isOn) {
    var wrapper = input.closest('[data-zb-consent]');

    if (!wrapper) {
      return;
    }

    wrapper.classList.toggle('zb-consent--error', isOn);
    input.setAttribute('aria-invalid', isOn ? 'true' : 'false');

    var message = wrapper.querySelector('[data-zb-consent-error]');

    if (message) {
      message.hidden = !isOn;
    }
  }

  // `invalid` does not bubble, hence the capture phase. The browser skips its own bubble and focus
  // when the event is cancelled, so the box is focused here.
  document.addEventListener('invalid', function (event) {
    var input = event.target;

    if (!isConsentInput(input)) {
      return;
    }

    event.preventDefault();
    setError(input, true);
    input.focus();
  }, true);

  // Saving on change lets the answer be checked in /cart.js without going to checkout. This request
  // does not re-render the cart; any later re-render comes back unticked (server markup), so the
  // shopper confirms again after changing the cart. The time also goes into the form's hidden field:
  // a tap on ÖDEME right after the tick can outrun (or abort) this request, and the checkout POST
  // then still carries answer, time and version together.
  document.addEventListener('change', function (event) {
    var input = event.target;

    if (!isConsentInput(input)) {
      return;
    }

    if (input.checked) {
      setError(input, false);
    }

    var time = input.checked ? new Date().toISOString() : '';
    var wrapper = input.closest('[data-zb-consent]');
    var timeField = wrapper && wrapper.querySelector('[data-zb-consent-time]');

    if (timeField) {
      timeField.value = time;
    }

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        attributes: {
          _on_bilgilendirme_onay: input.checked ? 'evet' : '',
          _on_bilgilendirme_zamani: time,
          _on_bilgilendirme_surum: input.dataset.zbConsentVersion || ''
        }
      })
    }).catch(function () {});
  });
}());

// ZERBAY Sürüm 2 (s2/33, plan step 8 §2.0/§2.2): "Numarayı değiştir" per cart line, drawer and /cart.
// Markup: snippets/cart-products.liquid ([data-zb-size]). Horizon's own cart code is not changed; this file watches it:
// a watch-only fetch wrapper counts Horizon's cart requests (cart URLs and Section Rendering requests for the cart
// sections) until their body has been read (+ one task, so Horizon's morph after the read has run). A swap starts only
// when nothing is counted, no cart component is disabled and the last quantity change has been sent (or 1 s passed).
// Swap: read the cart (S); raise the new size (change.js by its line key when it is in the cart, else update.js by
// variant id followed by change.js on the new line at the same quantity - update.js does not check stock, change.js
// does: P4-0 / P4-0b); re-read (C1); if the new size did not reach n + q, take back only what our own requests added,
// re-read (C2): L-22 for a stock refusal with the cart back to S, else contact.error; otherwise remove the old line by
// its current key (one retry), re-read; still there -> undo the raise -> contact.error. Every swap write asks for the
// cart sections; the views are morphed from the last write's answer (or a fresh render), never from older HTML; an
// unreadable cart or a failed render reloads the page. While it runs, every cart control that can write or leave is
// disabled and leaving the drawer / submitting is refused (window capture, before Horizon's handlers).
(function () {
  if (window.zbSizeInit || typeof window.fetch !== 'function') {
    return;
  }

  window.zbSizeInit = true;

  var nativeFetch = window.fetch;
  var pending = 0;
  var started = 0;
  var lastQuantity = 0;
  var sentSinceQuantity = true; // a counted request started after the last quantity change
  var swapping = false;
  var swapEnded = 0; // s2/33d: when the last swap released the controls
  var generation = 0;
  var watch = null;
  var lockObserver = null;
  var LOCK_SELECTOR = '.cart-items__remove, .quantity-selector button, .quantity-selector input, [data-zb-size-toggle], [data-zb-size-to], [data-zb-size-current], button[name="checkout"]';

  function routes() {
    return (window.Theme && window.Theme.routes) || {};
  }

  function components() {
    return Array.prototype.slice.call(document.querySelectorAll('cart-items-component[data-section-id]'));
  }

  function sectionIds() {
    return components().map(function (component) {
      return component.getAttribute('data-section-id');
    });
  }

  function counted(input) {
    var url;

    try {
      url = new URL(typeof input === 'string' ? input : (input && input.url) || String(input), window.location.href);
    } catch (error) {
      return false;
    }

    if (url.origin !== window.location.origin) {
      return false;
    }

    if (/^(\/[a-z]{2}(-[a-z]{2})?)?\/cart(\.js|\/|$)/i.test(url.pathname)) {
      return true;
    }

    var ids = sectionIds();
    var single = url.searchParams.get('section_id');
    var many = url.searchParams.get('sections');

    if (single && ids.indexOf(single.replace(/^shopify-section-/, '')) > -1) {
      return true;
    }

    return !!many && many.split(',').some(function (id) {
      return ids.indexOf(id.trim()) > -1;
    });
  }

  // Watch-only: the request, its answer and its body are passed on unchanged.
  window.fetch = function (input) {
    var result = nativeFetch.apply(this, arguments);

    if (!counted(input)) {
      return result;
    }

    var done = false;

    pending += 1;
    started += 1;
    sentSinceQuantity = true;

    if (watch) {
      watch.stop();
    }

    function finish() {
      if (done) {
        return;
      }

      done = true;
      window.setTimeout(function () {
        pending -= 1;
      }, 0);
    }

    return result.then(function (response) {
      var copy = null;

      try {
        copy = response.clone();
      } catch (error) {
        copy = null;
      }

      if (copy) {
        copy.text().then(finish, finish);
      } else {
        finish();
      }

      return response;
    }, function (error) {
      finish();
      throw error;
    });
  };

  document.addEventListener('quantity-selector:update', function () {
    lastQuantity = Date.now();
    sentSinceQuantity = false;

    if (watch) {
      watch.stop();
    }
  }, true);

  function idle() {
    if (pending > 0 || document.querySelector('cart-items-component.cart-items-disabled')) {
      return false;
    }

    var since = Date.now() - lastQuantity;

    return since >= 1000 || (since >= 350 && sentSinceQuantity);
  }

  function waitIdle(ms) {
    var start = Date.now();

    return new Promise(function (resolve) {
      (function check() {
        if (idle()) {
          resolve(true);
        } else if (Date.now() - start > ms) {
          resolve(false);
        } else {
          window.setTimeout(check, 50);
        }
      }());
    });
  }

  // ---- requests (not counted: they use the original fetch; each one is aborted after 30 s -> a failed write, or a
  // reload for a read / render). s2/33c: 30 s, not 15 s - the time runs from the fetch call, so a request that waits
  // behind other requests (slow phone network, the rate-limited preview checks) must not be cut while still queued.
  function limited(url, options) {
    var controller = window.AbortController ? new AbortController() : null;
    var timer = controller ? window.setTimeout(function () {
      controller.abort();
    }, 30000) : null;

    if (controller) {
      options.signal = controller.signal;
    }

    return nativeFetch.call(window, url, options).then(function (response) {
      return response.text().then(function (text) {
        window.clearTimeout(timer);
        return { ok: response.ok, status: response.status, text: text };
      });
    }, function (error) {
      window.clearTimeout(timer);
      throw error;
    });
  }

  function cartRead() {
    return limited((routes().cart_url || '/cart') + '.js', {
      cache: 'no-store',
      headers: { Accept: 'application/json' }
    }).then(function (answer) {
      var cart = answer.ok ? JSON.parse(answer.text) : null;

      if (!cart || !Array.isArray(cart.items)) {
        throw new Error('cart read ' + answer.status);
      }

      return cart;
    });
  }

  function cartPost(url, body) {
    body.sections = sectionIds().join(',');
    body.sections_url = window.location.pathname;

    return limited(url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (answer) {
      var cart = null;

      try {
        cart = JSON.parse(answer.text);
      } catch (error) {
        cart = null;
      }

      return { ok: answer.ok && !!cart && Array.isArray(cart.items), status: answer.status, cart: cart };
    }, function () {
      return { ok: false, status: 0, cart: null };
    });
  }

  function change(key, quantity) {
    return cartPost(routes().cart_change_url || '/cart/change', { id: key, quantity: quantity });
  }

  // a line the size change may touch: no selling plan, no properties, not a bundle or a bundle part, no protected quantity
  function plain(item) {
    if (!item || item.selling_plan_allocation || (item.properties && Object.keys(item.properties).length)) {
      return false;
    }

    if (item.has_components || (item.parent_relationship && (item.parent_relationship.parent_key || item.parent_relationship.parent))) {
      return false;
    }

    return !(item.instructions && (item.instructions.can_remove === false || item.instructions.can_update_quantity === false));
  }

  function lineOf(cart, variantId) {
    var lines = cart.items.filter(function (item) {
      return Number(item.variant_id) === Number(variantId);
    });

    return lines.length === 1 ? lines[0] : null;
  }

  function qtyOf(cart, variantId) {
    return cart.items.reduce(function (sum, item) {
      return Number(item.variant_id) === Number(variantId) ? sum + item.quantity : sum;
    }, 0);
  }

  // The old line in a cart: 'absent' (no line of the old variant), 'valid' (by its key - or, when the key changed, the
  // single line of the old variant - still with quantity q and eligible) or 'ambiguous' (never removed).
  function oldState(cart, op, q) {
    function fits(item) {
      return Number(item.variant_id) === op.from && item.quantity === q && plain(item);
    }

    var byKey = cart.items.filter(function (item) {
      return item.key === op.key;
    })[0];

    if (byKey) {
      return { state: fits(byKey) ? 'valid' : 'ambiguous', line: byKey };
    }

    var same = cart.items.filter(function (item) {
      return Number(item.variant_id) === op.from;
    });

    if (!same.length) {
      return { state: 'absent', line: null };
    }

    return { state: same.length === 1 && fits(same[0]) ? 'valid' : 'ambiguous', line: same[0] };
  }

  function firstNumber(text) {
    var match = typeof text === 'string' ? text.match(/\d+/) : null;

    return match ? Number(match[0]) : null;
  }

  function signature(cart) {
    return cart.items.map(function (item) {
      return item.key + ':' + item.quantity;
    }).sort().join('|');
  }

  // ---- lock ----------------------------------------------------------------------------------------------------
  // The value each control had is kept on the element (data-zb-lock); Horizon's morph drops the attribute, so a
  // re-rendered control is locked again with its own fresh value, and the release restores exactly that.
  function lockControls() {
    components().forEach(function (component) {
      each(component.querySelectorAll(LOCK_SELECTOR), function (el) {
        if (!el.hasAttribute('data-zb-lock')) {
          el.setAttribute('data-zb-lock', el.disabled ? '1' : '0');
        }

        if (!el.disabled) {
          el.disabled = true;
        }
      });
      each(component.querySelectorAll('.additional-checkout-buttons, shopify-accelerated-checkout-cart'), function (el) {
        if (!el.hasAttribute('data-zb-lock')) {
          el.setAttribute('data-zb-lock', '');
        }

        if (!el.inert) {
          el.inert = true;
        }
      });
    });
    // only real changes: the lock observer below must not see a mutation for an element that is already locked
    each(document.querySelectorAll('button[name="checkout"][form="cart-form"]'), function (el) {
      if (!el.hasAttribute('data-zb-lock')) {
        el.setAttribute('data-zb-lock', el.disabled ? '1' : '0');
      }

      if (!el.disabled) {
        el.disabled = true;
      }
    });
  }

  function unlockControls() {
    each(document.querySelectorAll('[data-zb-lock]'), function (el) {
      var value = el.getAttribute('data-zb-lock');

      el.removeAttribute('data-zb-lock');

      if (value === '') {
        el.inert = false;
      } else {
        el.disabled = value === '1';
      }
    });

    each(document.querySelectorAll('cart-quantity-selector-component'), function (selector) {
      if (typeof selector.updateButtonStates === 'function') {
        selector.updateButtonStates();
      }
    });
  }

  function startLock() {
    lockControls();

    if (window.MutationObserver) {
      lockObserver = new MutationObserver(function () {
        if (swapping) {
          lockControls();
        }
      });
      components().forEach(function (component) {
        lockObserver.observe(component, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });
      });
    }
  }

  function endLock() {
    if (lockObserver) {
      lockObserver.disconnect();
      lockObserver = null;
    }

    unlockControls();
  }

  // ---- picker --------------------------------------------------------------------------------------------------
  function toggle(box, open) {
    var button = box.querySelector('[data-zb-size-toggle]');
    var set = box.querySelector('[data-zb-size-set]');

    if (!button || !set) {
      return;
    }

    var next = typeof open === 'boolean' ? open : set.hidden;

    if (next) {
      var view = box.closest('cart-items-component') || document;

      each(view.querySelectorAll('[data-zb-size]'), function (other) {
        if (other !== box) {
          toggle(other, false);
        }
      });
    }

    set.hidden = !next;
    button.setAttribute('aria-expanded', next ? 'true' : 'false');
  }

  document.addEventListener('click', function (event) {
    var control = event.target && event.target.closest ? event.target.closest('[data-zb-size-toggle], [data-zb-size-to], [data-zb-size-current]') : null;
    var box = control ? control.closest('[data-zb-size]') : null;

    if (!box) {
      return;
    }

    event.preventDefault();

    if (control.hasAttribute('data-zb-size-toggle')) {
      toggle(box);
    } else if (control.hasAttribute('data-zb-size-to')) {
      pick(box, control);
    }
  });

  // Window capture: runs before Horizon's document-capture on:* handlers and the drawer's own listeners.
  window.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape' && event.key !== 'Esc') {
      return;
    }

    if (swapping) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }

    var active = document.activeElement;
    var box = active && active.closest ? active.closest('[data-zb-size]') : null;
    var set = box ? box.querySelector('[data-zb-size-set]') : null;

    if (!set || set.hidden) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    toggle(box, false);
    focusEl(box.querySelector('[data-zb-size-toggle]'));
  }, true);

  window.addEventListener('cancel', function (event) {
    if (swapping) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  window.addEventListener('click', function (event) {
    var target = event.target;

    // s2/33d: the picker closes after a swap and "Kaldır" moves up under the finger: a remove tap within 700 ms of the
    // release is taken as the second tap of the pick, not as a remove
    if (!swapping && Date.now() - swapEnded < 700 && target && target.closest && target.closest('.cart-items__remove')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }

    if (!swapping) {
      return;
    }

    var drawer = target && target.closest ? target.closest('cart-drawer-component') : null;
    var leave = (target && target.matches && target.matches('cart-drawer-component dialog')) ||
      (drawer && target.closest('.cart-drawer__close-button, [on\\:click*="close"]')) ||
      (target && target.closest && target.closest('.cart-items__remove'));

    if (leave) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  window.addEventListener('submit', function (event) {
    if (!swapping) {
      return;
    }

    var form = event.target;
    var action = form && form.getAttribute ? form.getAttribute('action') || '' : '';

    if (/\/cart(\/|\?|$)/.test(action) || (form.closest && form.closest('product-form-component, cart-items-component'))) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  // ---- messages ------------------------------------------------------------------------------------------------
  function texts(component) {
    var wrapper = component && component.querySelector('.cart-items__wrapper[data-zb-cart-error]');

    return {
      error: wrapper ? wrapper.getAttribute('data-zb-cart-error') : '',
      stock: wrapper ? wrapper.getAttribute('data-zb-cart-stock-error') : ''
    };
  }

  function region(component) {
    var drawer = component && component.closest('cart-drawer-component');
    var live = drawer ? drawer.querySelector('[ref="liveRegion"]') : null;

    if (live) {
      return live;
    }

    var main = document.querySelector('main') || document.body;
    var own = document.querySelector('[data-zb-cart-status]');

    if (!own || !own.isConnected) {
      own = document.createElement('p');
      own.className = 'visually-hidden';
      own.setAttribute('role', 'status');
      own.setAttribute('aria-live', 'polite');
      own.setAttribute('data-zb-cart-status', '');
      main.appendChild(own);
    }

    return own;
  }

  function announce(component, text) {
    var target = region(component);

    if (!target || !text) {
      return;
    }

    target.textContent = '';
    window.setTimeout(function () {
      target.textContent = text;
    }, 60);
  }

  function rowOf(component, key) {
    if (!component || !key) {
      return null;
    }

    return component.querySelector('tr[data-key="' + (window.CSS && CSS.escape ? CSS.escape(key) : key) + '"]');
  }

  function showError(component, key, message) {
    var row = rowOf(component, key);
    var cell = row ? row.querySelector('.cart-items__error') : null;
    var text = row ? row.querySelector('.cart-item__error-text') : null;

    if (cell && text) {
      text.textContent = message;
      cell.classList.remove('hidden');
    } else {
      announce(component, message);
    }
  }

  // ---- render --------------------------------------------------------------------------------------------------
  var modules = null;

  function loadModules() {
    if (!modules) {
      modules = Promise.all([import('@theme/section-renderer'), import('@theme/events')]).then(function (list) {
        return { sections: list[0], events: list[1] };
      });
      modules.catch(function () {
        modules = null;
      });
    }

    return modules;
  }

  function fetchSection(id, gen) {
    var url = new URL(window.location.href);

    url.searchParams.set('section_id', id);
    url.searchParams.set('_zb', String(gen));

    return limited(url.toString(), { cache: 'no-store' }).then(function (answer) {
      if (!answer.ok) {
        throw new Error('section ' + answer.status);
      }

      return answer.text;
    });
  }

  // the answer must be that section with its own cart component inside it
  function validSection(id, html) {
    if (typeof html !== 'string' || !html) {
      return false;
    }

    var doc = new DOMParser().parseFromString(html, 'text/html');
    var wrapper = doc.getElementById('shopify-section-' + id);
    var found = false;

    each(wrapper ? wrapper.querySelectorAll('cart-items-component') : [], function (component) {
      if (component.getAttribute('data-section-id') === id) {
        found = true;
      }
    });

    return found;
  }

  // Every cart component is morphed (awaited) from `sections` (the last write's answer) or a fresh render; each HTML must
  // be that section with its cart component, else the render fails (the caller reloads). Then one CartUpdateEvent from
  // the source component carries every component's HTML (badges, counts; the other component's handler re-morphs the
  // same HTML).
  function render(sourceId, cart, sections, gen) {
    return loadModules().then(function (mod) {
      var ids = sectionIds();

      return Promise.all(ids.map(function (id) {
        var html = sections && sections[id];

        if (validSection(id, html)) {
          return html;
        }

        return fetchSection(id, gen).then(function (fresh) {
          if (!validSection(id, fresh)) {
            throw new Error('section without cart');
          }

          return fresh;
        });
      })).then(function (list) {
        if (gen !== generation) {
          return false;
        }

        var all = {};

        ids.forEach(function (id, index) {
          all[id] = list[index];
        });

        var order = [sourceId].concat(ids.filter(function (id) {
          return id !== sourceId;
        }));

        var dropped = false;

        return order.reduce(function (chain, id) {
          return chain.then(function () {
            if (dropped || gen !== generation) {
              dropped = true; // a newer operation took over: nothing more of this render is applied
              return null;
            }

            var component = document.querySelector('cart-items-component[data-section-id="' + id + '"]');

            if (!component) {
              throw new Error('component gone');
            }

            return mod.sections.morphSection(id, all[id], { mode: component.hasAttribute('data-drawer') ? 'hydration' : 'full' });
          });
        }, Promise.resolve()).then(function () {
          if (dropped || gen !== generation) {
            return false;
          }

          if (swapping) {
            lockControls();
          }

          var fresh = document.querySelector('cart-items-component[data-section-id="' + sourceId + '"]') || components()[0];

          if (fresh) {
            fresh.dispatchEvent(new mod.events.CartUpdateEvent(cart, sourceId, {
              itemCount: cart.item_count,
              source: 'zb-size-change',
              sections: all
            }));
          }

          return true;
        });
      });
    });
  }

  function rendered(component) {
    return Array.prototype.map.call(component.querySelectorAll('tr[data-key]'), function (row) {
      var input = row.querySelector('input[name="updates[]"]');
      var quantity = input ? input.defaultValue : '';

      return row.getAttribute('data-key') + ':' + quantity;
    }).sort().join('|');
  }

  // After the final render: for 2 s a later morph that leaves line keys or quantities (also an empty view) different from
  // the final cart triggers one fresh re-read + re-render. A quantity tap, a remove or another counted cart request ends
  // the watch and drops a repair still in flight.
  function watchAfter(cart) {
    if (watch) {
      watch.stop();
    }

    if (!window.MutationObserver) {
      return;
    }

    var expected = cart.items.map(function (item) {
      return item.key + ':' + item.quantity;
    }).sort().join('|');
    var repairing = false;
    var observer = new MutationObserver(function () {
      if (repairing) {
        return;
      }

      var stale = components().some(function (component) {
        return rendered(component) !== expected;
      });

      if (!stale) {
        return;
      }

      repairing = true;
      observer.disconnect();
      window.clearTimeout(timer);
      generation += 1;

      var gen = generation;

      cartRead().then(function (fresh) {
        var first = components()[0];

        if (gen !== generation || !first) {
          return false;
        }

        return render(first.getAttribute('data-section-id'), fresh, null, gen);
      }).catch(function () {
        if (gen === generation) {
          window.location.reload();
        }
      }).then(function () {
        if (watch === current) {
          watch = null;
        }
      });
    });
    var timer = window.setTimeout(function () {
      current.stop();
    }, 2000);
    var current = {
      stop: function () {
        observer.disconnect();
        window.clearTimeout(timer);

        if (repairing) {
          generation += 1; // a newer cart operation: the repair's render is dropped
        }

        if (watch === current) {
          watch = null;
        }
      }
    };

    components().forEach(function (component) {
      observer.observe(component, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-key', 'value'] });
    });
    watch = current;
  }

  document.addEventListener('click', function (event) {
    if (watch && event.target && event.target.closest && event.target.closest('.cart-items__remove, .quantity-selector')) {
      watch.stop();
    }
  }, true);

  // ---- swap ----------------------------------------------------------------------------------------------------
  function pick(box, button) {
    if (swapping || button.disabled) {
      return;
    }

    var component = box.closest('cart-items-component');
    var op = {
      key: box.getAttribute('data-zb-size-key'),
      from: Number(box.getAttribute('data-zb-size-from')),
      to: Number(button.getAttribute('data-zb-size-to')),
      qty: parseInt(box.getAttribute('data-zb-size-qty'), 10),
      sourceId: component ? component.getAttribute('data-section-id') : null
    };

    if (!op.key || !op.to || !(op.qty > 0) || !op.sourceId) {
      return;
    }

    swapping = true;

    if (watch) {
      watch.stop();
    }

    focusEl(box.querySelector('.zb-size__legend'));
    startLock();
    run(op).catch(function () {
      window.location.reload();
    });
  }

  async function run(op) {
    var result = { kind: 'none', key: op.key, newKey: null };
    var last = null; // sections of the last write's answer (null when the last write did not answer with them)
    var finalCart;

    async function write(promise) {
      var answer = await promise;

      last = answer.ok && answer.cart.sections ? answer.cart.sections : null;
      return answer;
    }

    if (!(await waitIdle(15000))) {
      throw new Error('cart busy');
    }

    var startedAt = started;
    var S = await cartRead();
    var old = S.items.filter(function (item) {
      return item.key === op.key;
    })[0];
    var targets = S.items.filter(function (item) {
      return Number(item.variant_id) === op.to;
    });

    finalCart = S;

    if (old && Number(old.variant_id) === op.from && old.quantity === op.qty && plain(old) && targets.length <= 1 && (!targets.length || plain(targets[0]))) {
      var q = old.quantity;
      var n = targets.length ? targets[0].quantity : 0;
      var want = n + q;
      var answer;
      var enforcing = true; // the answer comes from change.js (Shopify checks stock there)
      var confirmed = null; // the new size's quantity as our last answered request confirms it
      var checkedFrom = n; // the new size's quantity just before the stock-checking change.js

      if (n > 0) {
        answer = await write(change(targets[0].key, want));
      } else {
        // update.js adds an absent variant without a stock check (P4-0); change.js on the new line at the same
        // quantity checks it (422 + capped, P4-0b)
        var updates = {};

        updates[op.to] = q;

        var added = await write(cartPost(routes().cart_update_url || '/cart/update', { updates: updates }));
        var addedLine = added.ok ? lineOf(added.cart, op.to) : null;

        if (addedLine && addedLine.quantity === q) {
          confirmed = q;
          checkedFrom = q;
          answer = await write(change(addedLine.key, q));
        } else {
          answer = added;
          enforcing = false;
        }
      }

      if (answer.ok) {
        confirmed = qtyOf(answer.cart, op.to);
      }

      var C1 = await cartRead();
      var got = qtyOf(C1, op.to);

      if (answer.ok && enforcing && confirmed === want && got === want) {
        // raised and stock-checked: remove the old line (one retry), only while it is still what we saw
        var now = C1;
        var state = oldState(now, op, q);
        var failed = false; // a removal request failed: contact.error even when the retry worked (plan §2.0)

        for (var attempt = 0; state.state === 'valid' && attempt < 2; attempt += 1) {
          var removal = await write(change(state.line.key, 0));

          if (!removal.ok) {
            failed = true;
          }

          now = await cartRead();
          state = oldState(now, op, q);
        }

        finalCart = now;

        if (state.state === 'absent') {
          var newLine = lineOf(now, op.to);

          result.kind = 'ok';
          result.newKey = newLine ? newLine.key : null;
          result.recovered = failed;
        } else {
          // not removed, or changed meanwhile: undo the raise while the new size still shows exactly n + q
          var raised = lineOf(now, op.to);

          if (raised && raised.quantity === want) {
            await write(change(raised.key, n));
            finalCart = await cartRead();
          }

          result.kind = 'error';
          result.key = state.line ? state.line.key : op.key;
        }
      } else {
        // not raised as asked. A stock refusal is identified positively: change.js capped the line (200 with less), or
        // answered 422 AND Shopify changed the line (the cap) to exactly the quantity its message names (P4-0). A 422
        // that left the line as it was is never read as a stock refusal.
        var capped = answer.ok && enforcing && confirmed < want;
        var refused = answer.status === 422 && enforcing && got >= n && got < want && got !== checkedFrom &&
          firstNumber(answer.cart && answer.cart.description) === got;
        // What our own requests added, never more than q (same rule as global zbCart.swapRun); anything ambiguous gets
        // no write and contact.error.
        var ours = null;

        if (answer.ok) {
          ours = confirmed - n;
        } else if (refused) {
          ours = got - n;
        } else if (confirmed !== null && got >= n && got <= confirmed) {
          ours = got - n;
        } else if (answer.status !== 422 && got === want) {
          // applied, answer lost: both raise requests set an absolute quantity (n + q), so exactly n + q is ours
          ours = q;
        } else if (got === n) {
          ours = 0;
        }

        if (ours !== null) {
          ours = Math.max(0, Math.min(q, ours));

          if (got - ours < 0) {
            ours = null;
          }
        }

        var line = lineOf(C1, op.to);
        var backFailed = false; // a failed take-back keeps contact.error even when the cart came back (plan §2.0)

        if (ours > 0 && line && line.quantity === got) {
          backFailed = !(await write(change(line.key, got - ours))).ok;
        } else {
          last = null;
        }

        var C2 = await cartRead();

        finalCart = C2;
        result.kind = ours !== null && !backFailed && (capped || refused) && signature(C2) === signature(S) ? 'stock' : 'error';
      }
    }

    generation += 1;
    await render(op.sourceId, finalCart, last, generation);

    if (started !== startedAt) {
      // an outside cart request started during the swap: render once more after it has settled
      var again = started;

      if (!(await waitIdle(15000))) {
        throw new Error('cart busy');
      }

      finalCart = await cartRead();
      generation += 1;
      await render(op.sourceId, finalCart, null, generation);

      if (started !== again) {
        throw new Error('cart busy');
      }
    }

    swapping = false;
    swapEnded = Date.now();
    endLock();

    var source = document.querySelector('cart-items-component[data-section-id="' + op.sourceId + '"]');
    var info = texts(source);
    var row = rowOf(source, result.kind === 'ok' ? result.newKey : result.key);
    var target = row ? row.querySelector('[data-zb-size-toggle]') || row.querySelector('.cart-items__title') : null;

    if (!target && source) {
      target = source.querySelector('[data-zb-size-toggle], .cart-drawer__close-button, a[href]');
    }

    focusEl(target);

    if (result.kind === 'ok' && row) {
      var variants = row.querySelector('.cart-items__variants');

      announce(source, variants ? variants.textContent.replace(/\s+/g, ' ').trim() : '');

      if (result.recovered) {
        showError(source, result.newKey, info.error);
      }
    } else if (result.kind === 'stock') {
      showError(source, result.key, info.stock);
    } else if (result.kind === 'error') {
      showError(source, result.key, info.error);
    }

    watchAfter(finalCart);
  }

  function each(list, fn) {
    Array.prototype.forEach.call(list || [], fn);
  }

  function focusEl(element) {
    if (!element || typeof element.focus !== 'function') {
      return;
    }

    try {
      element.focus({ preventScroll: true });
    } catch (error) {
      element.focus();
    }
  }
}());

(function () {
  /* Checkout button feedback (s3/08, B-03). One IIFE, idempotent. A tap on button[name="checkout"] marks it busy
     (aria-busy + aria-disabled; never `disabled`, which would drop the button from the form data and Shopify would
     return to /cart). A second submit from a busy button is cancelled. CSS: global sections/static-header.liquid, TR assets/zerbay-header.css. */
  var rootEl = document.documentElement;
  if (rootEl.hasAttribute('data-zb-co-js')) return;
  rootEl.setAttribute('data-zb-co-js', '');

  var timer = 0;

  function reset() {
    window.clearTimeout(timer);
    var busy = document.querySelectorAll('button[name="checkout"][aria-busy="true"]');
    for (var i = 0; i < busy.length; i++) {
      busy[i].removeAttribute('aria-busy');
      busy[i].removeAttribute('aria-disabled');
    }
  }

  document.addEventListener('submit', function (e) {
    if (e.defaultPrevented) return;
    var btn = e.submitter;
    if (!btn || !btn.matches || !btn.matches('button[name="checkout"]')) return;
    if (btn.getAttribute('aria-busy') === 'true') { e.preventDefault(); return; }
    btn.setAttribute('aria-busy', 'true');
    btn.setAttribute('aria-disabled', 'true');
    window.clearTimeout(timer);
    timer = window.setTimeout(reset, 15000);
  });

  window.addEventListener('pageshow', function (e) {
    if (e.persisted) reset();
  });
})();

(function () {
  /* Photo shimmer (s3/15, owner 10.10). One IIFE, idempotent. Marks the box of a photo that has not loaded yet
     (.zb-card .product-card-figure, .zb-styles__photo, a product-page image slide) with .zb-shimmer + .is-loading; on the
     photo's load / error (and rimg's rimg:load, the global lazy photos) .is-loading becomes .is-loaded; a native error
     settles the box even when rimg still says "loading". .is-near (IntersectionObserver, 200px margin) lets only boxes
     in or near the viewport sweep. Photos that are already in are never marked. A MutationObserver picks up boxes added later (filters, paging, section reloads, cart lines) and a photo whose src / srcset / hidden changes later (card colour swap, TR swatch photo).
     CSS: the "Photo shimmer" block at the end of global assets/theme.css.liquid / TR assets/zerbay-theme.css. */
  var rootEl = document.documentElement;
  if (rootEl.hasAttribute('data-zb-shim-js')) return;
  rootEl.setAttribute('data-zb-shim-js', '');

  var BOXES = [
    '.zb-card .product-card-figure', '.zb-styles__photo', '.product-gallery--viewport--figure[data-media-type="image"]',
    '.ls-results .predictive-search__product-suggestion-image', '.zb-predictive-product-card__media',
    '.zb-occ__th', '.zb-cer__tile-photo', '.zb-cer__tile-media', '.zb-idx__thumb', '.zb-idx__th', '.zb-idx__cell',
    '.zb-atl__photo', '.zb-rev__photo', '.agg-review__hero', '.product-gallery--zb-thumb',
    '.color-option-item .option-value-name', '.zb-product-swatch-thumb',
    '.zb-cart-line__media', 'td.product-image .image', '.cart-items__media-container',
    '.collection-card__image.resource-image', '.collections .collection'
  ].join(', ');

  var near = null;
  var watched = null; /* the boxes the observer holds, so detached ones can be let go */
  if ('IntersectionObserver' in window && typeof Set === 'function') {
    watched = new Set();
    near = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        entries[i].target.classList.toggle('is-near', entries[i].isIntersecting);
      }
    }, { rootMargin: '200px' });
  }

  function watch(box) {
    if (!near) { box.classList.add('is-near'); return; }
    if (watched.has(box)) return;
    watched.add(box);
    near.observe(box);
  }

  function unwatch(box) {
    box.classList.remove('is-near');
    if (near && watched.has(box)) {
      watched.delete(box);
      near.unobserve(box);
    }
  }

  function pending(img, failed) {
    if (failed || img.hidden) return false;
    var state = img.getAttribute('data-rimg');
    if (img.complete && img.naturalWidth === 0 && state !== 'lazy') return false;
    if (state === 'lazy' || state === 'loading') return true;
    return !img.complete;
  }

  function probeBg(box, url) {
    box.zbShimBg = url;
    var done = function () {
      box.zbShimBgDone = url;
      if (box.isConnected) sync(box);
    };
    var probe = new Image();
    probe.onload = done;
    probe.onerror = done;
    probe.src = url;
  }

  function sync(box, failed) {
    var cl = box.classList;
    var pend = false;
    var img = null;
    if (box.hasAttribute('data-rimg')) {
      /* a background-image box (global /collections): rimg sets the state on the box itself and fires rimg:load / rimg:error on it.
         Its loader never hears about a failed background (it only sets image.onload), so the background URL is probed here once. */
      var state = box.getAttribute('data-rimg');
      if (state === 'lazy') pend = !failed;
      else if (state === 'loading') {
        var m = /url\(["']?([^"')]+)/.exec(box.style.backgroundImage || '');
        var url = m ? m[1] : '';
        if (url && box.zbShimBg !== url) probeBg(box, url);
        pend = !failed && !(url && box.zbShimBgDone === url);
      }
    } else {
      img = box.querySelector('img:not(.zb-card-hover-image)');
      pend = !!img && pending(img, failed); /* no photo (taken out of a loading box): settle */
    }
    var seen = box.zbShimShown; /* a card that has displayed its photo keeps it while a colour preview loads */
    if (!pend && img && img.naturalWidth > 0) box.zbShimShown = true;
    if (pend && seen && !cl.contains('is-loading') && box.matches('.zb-card .product-card-figure')) {
      /* a card that already showed its photo keeps it while a colour preview loads (the browser keeps the old photo until the new one is in) */
      if (watched && watched.has(box)) unwatch(box);
    } else if (pend) {
      if (!cl.contains('is-loading')) {
        cl.add('zb-shimmer');
        cl.remove('is-loaded');
        cl.add('is-loading');
        unwatch(box); /* a renderer (Horizon morph, morphdom) may have reset this box's classes while it was watched: observe it afresh */
      }
      watch(box); /* also a pending box that was removed and put back */
    } else {
      if (cl.contains('is-loading')) {
        cl.remove('is-loading');
        cl.add('is-loaded');
      }
      if (watched && watched.has(box)) unwatch(box);
    }
  }

  function scan(node) {
    if (!node || node.nodeType !== 1) return;
    if (node.tagName === 'IMG') {
      var own = node.closest(BOXES);
      if (own) sync(own);
      return;
    }
    if (node.matches(BOXES)) sync(node);
    var found = node.querySelectorAll(BOXES);
    for (var i = 0; i < found.length; i++) sync(found[i]);
    var up = node.closest(BOXES);
    if (up && up !== node) sync(up);
  }

  function settle(e) {
    var t = e.target;
    if (!t || t.nodeType !== 1) return;
    var box = t.closest(BOXES);
    if (!box) return;
    if (t.tagName === 'IMG') {
      var main = box.querySelector('img:not(.zb-card-hover-image)');
      sync(box, e.type === 'error' && t === main);
    } else if (t === box && box.hasAttribute('data-rimg')) {
      sync(box, e.type === 'error' || box.getAttribute('data-rimg') === 'error');
    }
  }

  document.addEventListener('load', settle, true);
  document.addEventListener('error', settle, true);
  document.addEventListener('rimg:load', settle, true);
  document.addEventListener('rimg:loading', function (e) {
    var t = e.target;
    /* the loader sets the background right after this event: look at the box once it has */
    if (t && t.nodeType === 1 && t.hasAttribute('data-rimg') && t.matches(BOXES)) Promise.resolve().then(function () { if (t.isConnected) sync(t); });
  }, true);

  if ('MutationObserver' in window) {
    new MutationObserver(function (records) {
      var removed = false;
      var swapped = null;
      for (var i = 0; i < records.length; i++) {
        var rec = records[i];
        if (rec.type === 'attributes') {
          /* a photo's src / srcset changed (card colour swap, swatch photo set later) or it was shown / hidden: look again once the
             browser has started the new request, which happens after this callback, not before */
          if (rec.target.tagName === 'IMG') {
            var sbox = rec.target.closest(BOXES);
            if (sbox && (!swapped || swapped.indexOf(sbox) < 0)) (swapped || (swapped = [])).push(sbox);
          }
          continue;
        }
        var added = rec.addedNodes;
        for (var j = 0; j < added.length; j++) scan(added[j]);
        if (rec.removedNodes.length) {
          removed = true;
          var holder = rec.target.nodeType === 1 ? rec.target.closest(BOXES) : null;
          if (holder && holder.classList.contains('is-loading')) sync(holder);
        }
      }
      if (swapped) {
        Promise.resolve().then(function () {
          for (var k = 0; k < swapped.length; k++) {
            if (swapped[k].isConnected) sync(swapped[k]); /* a box removed in the same batch is not observed again */
          }
        });
      }
      /* One pass per batch, after the additions: a box that was only moved is connected again and stays watched. */
      if (removed && watched && watched.size) {
        watched.forEach(function (box) { if (!box.isConnected) unwatch(box); });
      }
    }).observe(rootEl, { childList: true, subtree: true, attributes: true, attributeFilter: ['src', 'srcset', 'hidden'] });
  }

  scan(rootEl);
})();
